module.exports = __webpack_public_path__ + "img/level-icon.0d593b7f.png";